import { UserModel } from '@core/models/user-model';
import { createReducer, on } from '@ngrx/store';
import { Login, Logout } from './auth.actions';

export interface AuthState {
  loggedIn: boolean;
  user: UserModel | undefined;
}

export const initialAuthState: AuthState = {
  loggedIn: false,
  user: undefined,
};

export const authReducer = createReducer(
  initialAuthState,
  on(Login, (state) => ({
    ...state,
    error: null,
    pending: true,
  })),
  on(Logout, () => initialAuthState)
);
